import type {WidgetType} from "constants/WidgetConstants";
import * as React from "react";
import type {WidgetProps, WidgetState} from "widgets/BaseWidget";
import TaroWidget from "widgetsTaro";
import {ValidationTypes} from "constants/WidgetValidation";
import type {Stylesheet} from "entities/AppTheming";
import {DefaultAutocompleteDefinitions} from "widgets/WidgetUtils";
import type {AutocompletionDefinitions} from "widgets/constants";
import TCheckboxWidget from "../component";
import {EventType} from "../../../constants/AppsmithActionConstants/ActionConstants";
import {DerivedPropertiesMap} from "../../../utils/WidgetFactory";
import {SelectWidgetProps} from "../../../widgets/SelectWidget/widget";
import {EvaluationSubstitutionType} from "../../../entities/DataTree/types";
import {fontSizeOptions} from "../../../pages/Editor/ThemePropertyPane/controls/ThemeFormControl";
import {FontStyleTypes} from "constants/WidgetConstants";
import {isAutoLayout} from "../../../utils/autoLayout/flexWidgetUtils";
import {LabelPosition} from "../../../components/constants";
import {Alignment} from "@blueprintjs/core";
import type {BaseInputWidgetProps} from "../../../widgets/BaseInputWidget/widget";
import contentConfig from "./contentConfig";
import styleConfig from "./styleConfig";

class TCheckbox extends TaroWidget<TCheckboxWidgetProps, WidgetState> {
  constructor(props: TCheckboxWidgetProps) {
    super(props);
  }
  static getAutocompleteDefinitions(): AutocompletionDefinitions {
    return {
      value: "string",
      isVisible: DefaultAutocompleteDefinitions.isVisible,
    };
  }
  static getPropertyPaneEventsConfig() {
    return super.getWidgetEvents("AtCheckboxWidget");
  }
  static getDefaultPropertiesMap(): Record<string, string> {
    return {
      value: "defaultOptionValue"
    };
  }
  static getPropertyPaneContentConfig = contentConfig;
  static getPropertyPaneStyleConfig = styleConfig;

  static getDerivedPropertiesMap(): DerivedPropertiesMap {
    return {
      getValue: `{{ this.value }}`,
      isValid: `{{ this.isRequired ? this.value?.length!==0 : true }}`
    };
  }

  static getStylesheetConfig(): Stylesheet {
    return {
      borderRadius: "{{appsmith.theme.borderRadius.appBorderRadius}}",
      boxShadow: "none",
      backgroundColor: "{{appsmith.theme.form.inputBorder.bgColor}}",
      fontSize: "{{appsmith.theme.form.label.fontSize}}",
      color: "{{appsmith.theme.form.label.fontColor}}",
      bgColor: "{{appsmith.theme.form.inputBorder.bgColor}}",
      fontStyle: "{{appsmith.theme.form.label.fontStyle}}",
      inputFontSize: "{{appsmith.theme.form.inputText.fontSize}}",
      inputColor: "{{appsmith.theme.form.inputText.fontColor}}",
      inputFontStyle: "{{appsmith.theme.form.inputText.fontStyle}}",
    };
  }
  updateWidgetProperty = (propertyValues: string) => {
    if(propertyValues != this.props.value){
      this.onOptionChange();
      this.props.updateWidgetMetaProperty("value", propertyValues);
    }
  }
  onOptionChange = ()=>{
    if(this.props.onOptionChange){
      super.executeAction({
        triggerPropertyName: "onOptionChange",
        dynamicString: this.props.onOptionChange,
        event: {
          type: EventType.ON_OPTION_CHANGE,
        }
      })
    }
  }

  getPageView() {
    return (
      <TCheckboxWidget {...this.props} updateWidgetProperty={this.updateWidgetProperty} />
    );
  }


  static getWidgetType(): WidgetType {
    return "AT_CHECKBOX_WIDGET";
  }
}

export interface TCheckboxWidgetProps extends WidgetProps {
  value: any[];
  label: string;
  onClick?: any;
  borderRadius: string;
  boxShadow?: string;
}

export default TCheckbox;
